import React from "react";
import ScreenHeader from "../../../../CommonComponents/ScreenHeader";
import DescriptionText from "../../../../CommonComponents/DescriptionText";
import "./Promote.css";
import TabNav from "../../../../CommonComponents/TabNav/TabNav";
import { useNavigate } from "react-router-dom";
import Posters from "./Posters/Posters";
import PromoteQrCodes from "./QrCodes/QrCodes";
import ChantAssets from "./Assets/ChantAssets";

const PROMOTE_POSTER = "poster";
const PROMOTE_QR = "qr";
const PROMOTE_ASSETS = "assets";

const Promote = () => {
  const navigate = useNavigate();

  const menuItems = [
    {
      key: PROMOTE_POSTER,
      label: "Social Post",
    },
    {
      key: PROMOTE_QR,
      label: "Logo / QR",
    },
    {
      key: PROMOTE_ASSETS,
      label: "Chant Assets",
    },
  ];

  const getCurrentTab = () => {
    if (location.pathname.includes(PROMOTE_ASSETS)) {
      return PROMOTE_ASSETS;
    }
    if (location.pathname.includes(PROMOTE_QR)) {
      return PROMOTE_QR;
    }
    return PROMOTE_POSTER;
  };

  const handleTabChange = (tabKey) => {
    switch (tabKey) {
      case PROMOTE_POSTER:
        navigate("/admin/members/promote");
        break;

      case PROMOTE_QR:
        navigate("/admin/members/promote/qr");
        break;

      case PROMOTE_ASSETS:
        navigate("/admin/members/promote/assets");
        break;

      default:
        navigate("/admin/members/promote");
    }
  };

  const renderContent = () => {
    if (location.pathname.includes(PROMOTE_ASSETS)) {
      return <ChantAssets />;
    }
    if (location.pathname.includes(PROMOTE_QR)) {
      return <PromoteQrCodes />;
    }
    return <Posters />;
  };

  const renderDescription = () => {
    if (getCurrentTab() === "poster") {
      return (
        <>
          Please spread the word! Share this as a{" "}
          <a
            href="https://help.instagram.com/3526836317546926/?cms_platform=iphone-app&helpref=platform_switcher"
            target="_blank"
            rel="noopener noreferrer"
          >
            collaborative Instagram post
          </a>{" "}
          with Chant (@thechantapp) and across your social accounts. For
          additional color options change colors in Settings / Design.
        </>
      );
    }

    if (getCurrentTab() === "qr") {
      return (
        <>
          Include a QR code to help members onboard. Set up a custom code in
          Members/Onboard (option #4).{" "}
        </>
      );
    }
    return (
      <>
        Add the Chant logo to your social posts and mention us (@thechantapp).
      </>
    );
  };

  return (
    <div style={{ padding: "12px" }}>
      <ScreenHeader title="Promote" />

      <div style={{ paddingTop: "2px" }}>
        <TabNav
          items={menuItems}
          activeKey={getCurrentTab()}
          handleTabChange={handleTabChange}
        />
      </div>

      <div>
        <DescriptionText showBackground>{renderDescription()}</DescriptionText>
      </div>

      <div>{renderContent()}</div>
    </div>
  );
};

export default Promote;
